import { render, staticRenderFns } from "./ProsegurPay.vue?vue&type=template&id=b8a71736"
import script from "./ProsegurPay.vue?vue&type=script&lang=ts"
export * from "./ProsegurPay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports